import { useRef } from "react";
import { api } from "@/lib/api";

// One Idempotency-Key per money operation: a network retry reuses it (no double debit); any server answer resets it.
export function useIdempotentPost(prefix) {
  const ref = useRef(null);
  return async (path, body) => {
    if (!ref.current) ref.current = `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    try {
      const r = await api.post(path, body, { headers: { "Idempotency-Key": ref.current } });
      ref.current = null;
      return r;
    } catch (e) {
      if (e?.response) ref.current = null;
      throw e;
    }
  };
}
